export interface ManhwaItem {
  title: string;
  author: string;
  score: number;
  genre: string;
  tags: string[];
  desc: string;
  cover: string;
}

export interface RankItem extends ManhwaItem {
  rank: number;
}

export interface GenreItem {
  name: string;
  en: string;
  count: string;
  desc: string;
  cover: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const heroCover =
  "https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20webtoon%20collage%20illustration%20of%20young%20heroes%20and%20fantasy%20characters%20gathered%20together%2C%20bold%20warm%20coral%20orange%20and%20teal%20color%20palette%2C%20dynamic%20dramatic%20lighting%2C%20painterly%20comic%20art%20style%2C%20energetic%20composition%2C%20abstract%20colorful%20background&width=1600&height=900&seq=manhwa-hero-01&orientation=landscape";

export const topRankList: RankItem[] = [
  {
    rank: 1,
    title: "猎魔人笔记",
    author: "姜以勋",
    score: 9.7,
    genre: "奇幻冒险",
    tags: ["爽文", "升级流", "怪物"],
    desc: "末代猎魔人执笔写下的驱魔手记，在血月降临之前，他决定守护整座城市。剧情紧凑、战斗分镜凌厉，是公认的年度现象级作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20of%20a%20determined%20young%20monster%20hunter%20holding%20a%20glowing%20magic%20sword%2C%20dark%20fantasy%20atmosphere%2C%20bold%20coral%20and%20teal%20colors%2C%20dramatic%20lighting%2C%20dynamic%20composition%2C%20clean%20flat%20background%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-01&orientation=portrait",
  },
  {
    rank: 2,
    title: "星辰之约",
    author: "林序妍",
    score: 9.6,
    genre: "浪漫奇幻",
    tags: ["甜宠", "命运", "青梅竹马"],
    desc: "两名被星象预言绑定的少年，在无数个平行世界里相遇、错过、再重逢。画面唯美浪漫，情感刻画细腻，被称为「漫改界清流」。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20romantic%20fantasy%20couple%20gazing%20at%20each%20other%20under%20a%20starry%20night%20sky%2C%20dreamy%20pastel%20coral%20and%20teal%20lighting%2C%20soft%20painterly%20style%2C%20cinematic%20composition%2C%20clean%20simple%20background%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-02&orientation=portrait",
  },
  {
    rank: 3,
    title: "都市守夜人",
    author: "朴在容",
    score: 9.5,
    genre: "都市悬疑",
    tags: ["侦探", "犯罪", "霓虹"],
    desc: "白天是普通便利店店员，夜晚则是都市传说中的守夜人。硬朗的画风配上烧脑的连环案件，让每一话都充满悬念。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20mysterious%20trench%20coat%20detective%20standing%20in%20a%20rainy%20neon%20city%20alley%20at%20night%2C%20noir%20thriller%20mood%2C%20teal%20and%20warm%20orange%20neon%20lighting%2C%20dramatic%20cinematic%20composition%2C%20clean%20background%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-03&orientation=portrait",
  },
  {
    rank: 4,
    title: "血族纪元",
    author: "车泰亨",
    score: 9.4,
    genre: "暗黑哥特",
    tags: ["吸血鬼", "权谋", "宿命"],
    desc: "在人族与血族共存的千年王朝里，一个被流放的少年王子试图改写既定的命运。世界观宏大，人物弧光完整。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20gothic%20vampire%20noble%20prince%20in%20ornate%20dark%20robes%2C%20blood%20red%20and%20deep%20teal%20palette%2C%20dramatic%20candlelight%2C%20ornate%20castle%20background%2C%20elegant%20painterly%20style%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-04&orientation=portrait",
  },
  {
    rank: 5,
    title: "校服之下",
    author: "南多恩",
    score: 9.3,
    genre: "校园恋爱",
    tags: ["纯爱", "成长", "双向暗恋"],
    desc: "一段发生在高中教室里的双向暗恋，从校服袖口的一根线头开始。日常治愈、节奏舒缓，是睡前必读的温柔系作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20two%20shy%20high%20school%20students%20in%20uniforms%20in%20a%20bright%20sunlit%20classroom%2C%20sweet%20youthful%20romance%2C%20soft%20warm%20coral%20and%20cream%20tones%2C%20gentle%20lighting%2C%20clean%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-05&orientation=portrait",
  },
  {
    rank: 6,
    title: "龙庭记",
    author: "郑雅凛",
    score: 9.3,
    genre: "王朝权谋",
    tags: ["宫廷", "龙族", "计谋"],
    desc: "少年龙骑入主风雨飘摇的龙庭，在忠臣与叛党之间步步为营。权谋线与成长线并进，人物塑造令人过目难忘。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20young%20dragon%20knight%20standing%20before%20a%20majestic%20throne%20room%20with%20a%20massive%20dragon%2C%20east%20asian%20fantasy%20court%20setting%2C%20warm%20gold%20and%20teal%20palette%2C%20dramatic%20lighting%2C%20grand%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-06&orientation=portrait",
  },
  {
    rank: 7,
    title: "机械之心",
    author: "金泰延",
    score: 9.2,
    genre: "科幻机甲",
    tags: ["末世", "机器人", "战斗"],
    desc: "在人工智能觉醒的废墟都市里，一台拥有人类心脏的机甲少女寻找自我。设定新颖，泪点与燃点并存。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20futuristic%20android%20girl%20with%20glowing%20core%20and%20mecha%20armor%20in%20a%20post-apocalyptic%20city%2C%20sci-fi%20style%2C%20teal%20and%20coral%20neon%20accents%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-07&orientation=portrait",
  },
  {
    rank: 8,
    title: "迷雾岛",
    author: "宋知延",
    score: 9.1,
    genre: "生存悬疑",
    tags: ["孤岛", "解谜", "反转"],
    desc: "一场旅行事故让二十名乘客滞留迷雾笼罩的孤岛，岛上的规则却比海雾更神秘。层层反转，不到最后猜不到真相。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20group%20of%20survivors%20stranded%20on%20a%20mysterious%20misty%20isolated%20island%2C%20eerie%20atmospheric%20thriller%20mood%2C%20muted%20teal%20and%20cool%20tones%20with%20warm%20highlights%2C%20cinematic%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-08&orientation=portrait",
  },
  {
    rank: 9,
    title: "甜点工坊",
    author: "尹彩琳",
    score: 9.0,
    genre: "治愈日常",
    tags: ["美食", "经营", "治愈"],
    desc: "辞去高薪工作的甜点师回到家乡，用一间小小的工坊治愈每一位顾客的心事。画风清新，隔着屏幕都能闻到奶油香。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20cheerful%20young%20pastry%20chef%20in%20a%20cozy%20warm%20bakery%20with%20colorful%20desserts%20and%20cakes%2C%20cute%20heartwarming%20style%2C%20soft%20coral%20and%20cream%20tones%2C%20bright%20inviting%20lighting%2C%20clean%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-09&orientation=portrait",
  },
  {
    rank: 10,
    title: "拳王之路",
    author: "李俊昊",
    score: 9.0,
    genre: "热血竞技",
    tags: ["拳击", "励志", "逆袭"],
    desc: "从地下拳场一路打上全国联赛的落魄拳手，用汗水与拳头重新定义自己的价值。动作场面酣畅淋漓，燃到骨子里。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20determined%20muscular%20boxer%20with%20fists%20raised%20in%20a%20dramatic%20boxing%20ring%2C%20gritty%20sports%20action%20style%2C%20warm%20coral%20spotlights%20and%20dark%20background%2C%20dynamic%20motion%2C%20high%20contrast%20lighting%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-rank-10&orientation=portrait",
  },
];

export const highScoreList: ManhwaItem[] = [
  {
    title: "遗落的王国",
    author: "崔世英",
    score: 9.6,
    genre: "史诗奇幻",
    tags: ["王国", "冒险", "宏大"],
    desc: "被历史遗忘的古老王国重新崛起，一场横跨大陆的史诗冒险就此展开。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20heroic%20adventurer%20overlooking%20a%20grand%20floating%20kingdom%20in%20the%20clouds%2C%20epic%20fantasy%20scale%2C%20warm%20golden%20and%20teal%20palette%2C%20majestic%20dramatic%20lighting%2C%20sweeping%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-high-01&orientation=portrait",
  },
  {
    title: "时间旅人",
    author: "河相佑",
    score: 9.5,
    genre: "科幻哲思",
    tags: ["穿越", "选择", "思辨"],
    desc: "能够回溯时间三分钟的少年，在一次次重来中思考「改变」的真正代价。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20young%20time%20traveler%20standing%20before%20a%20surreal%20glowing%20clock%20tower%20with%20swirling%20time%20vortex%2C%20philosophical%20sci-fi%20mood%2C%20teal%20and%20coral%20neon%20palette%2C%20ethereal%20lighting%2C%20cinematic%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-high-02&orientation=portrait",
  },
  {
    title: "王牌召唤师",
    author: "沈在贤",
    score: 9.4,
    genre: "奇幻竞技",
    tags: ["召唤", "对战", "热血"],
    desc: "能与灵兽缔结契约的少女召唤师，在选拔赛场上向最强王牌发起挑战。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20young%20summoner%20girl%20calling%20forth%20a%20majestic%20spirit%20beast%20with%20glowing%20magic%20circle%2C%20fantasy%20battle%20style%2C%20bold%20coral%20and%20teal%20colors%2C%20dynamic%20action%20pose%2C%20clean%20background%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-high-03&orientation=portrait",
  },
  {
    title: "雨夜的你",
    author: "文采妍",
    score: 9.4,
    genre: "都市言情",
    tags: ["久别重逢", "治愈", "成年爱情"],
    desc: "多年后在雨夜重逢的两个人，在成年人的克制与心动之间反复试探。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20an%20elegant%20couple%20sharing%20an%20umbrella%20in%20a%20glowing%20rainy%20city%20street%20at%20night%2C%20mature%20romance%20mood%2C%20teal%20rain%20and%20warm%20orange%20lamplight%2C%20soft%20cinematic%20lighting%2C%20clean%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-high-04&orientation=portrait",
  },
  {
    title: "深渊回响",
    author: "权昭伊",
    score: 9.3,
    genre: "暗黑悬疑",
    tags: ["克苏鲁", "深海", "惊悚"],
    desc: "深海考察队带回一段无法解读的回响，深渊开始回应每一个听到它的人。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20lone%20diver%20facing%20a%20colossal%20glowing%20creature%20in%20the%20deep%20dark%20ocean%20abyss%2C%20cosmic%20horror%20mood%2C%20deep%20teal%20and%20eerie%20coral%20glow%2C%20dramatic%20underwater%20lighting%2C%20cinematic%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-high-05&orientation=portrait",
  },
  {
    title: "云端图书馆",
    author: "具瑟琪",
    score: 9.3,
    genre: "奇幻治愈",
    tags: ["知识", "冒险", "静谧"],
    desc: "漂浮在云端的图书馆里，每本书都是一个等待被翻开的世界。设定浪漫，画面治愈。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20dreamy%20floating%20library%20among%20soft%20clouds%20with%20books%20and%20warm%20glowing%20lanterns%2C%20whimsical%20fantasy%20mood%2C%20warm%20coral%20and%20soft%20teal%20palette%2C%20gentle%20ethereal%20lighting%2C%20cozy%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-high-06&orientation=portrait",
  },
];

export const genreList: GenreItem[] = [
  {
    name: "奇幻冒险",
    en: "Fantasy",
    count: "320+ 部",
    desc: "异世界、魔法、龙族与史诗旅程，想象力的无边界狂欢。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20of%20a%20young%20adventurer%20with%20magic%20staff%20facing%20a%20giant%20dragon%20and%20floating%20islands%2C%20epic%20fantasy%2C%20warm%20coral%20and%20teal%20palette%2C%20dynamic%20dramatic%20composition%2C%20painterly%20art%20style%2C%20high%20detail%20illustration&width=600&height=400&seq=manhwa-genre-01&orientation=landscape",
  },
  {
    name: "恋爱甜宠",
    en: "Romance",
    count: "280+ 部",
    desc: "双向暗恋、久别重逢与命运邂逅，甜到心坎的恋爱物语。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20of%20a%20romantic%20couple%20surrounded%20by%20blooming%20cherry%20blossoms%20and%20soft%20hearts%2C%20sweet%20pastel%20romance%20mood%2C%20warm%20coral%20and%20cream%20palette%2C%20dreamy%20soft%20lighting%2C%20clean%20composition%2C%20high%20detail%20illustration&width=600&height=400&seq=manhwa-genre-02&orientation=landscape",
  },
  {
    name: "热血战斗",
    en: "Action",
    count: "210+ 部",
    desc: "拳拳到肉的动作场面与逆袭成长，燃尽每一条神经。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20of%20a%20powerful%20martial%20artist%20charging%20forward%20with%20fiery%20energy%20aura%2C%20intense%20action%20combat%2C%20bold%20coral%20and%20dark%20teal%20palette%2C%20dramatic%20dynamic%20motion%20blur%2C%20high%20contrast%20lighting%2C%20high%20detail%20illustration&width=600&height=400&seq=manhwa-genre-03&orientation=landscape",
  },
  {
    name: "悬疑惊悚",
    en: "Thriller",
    count: "180+ 部",
    desc: "烧脑案件与层层反转，在迷雾深处逼近真相。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20of%20a%20silhouetted%20detective%20figure%20in%20a%20foggy%20dark%20forest%20with%20glowing%20red%20clues%2C%20suspenseful%20thriller%20mood%2C%20deep%20teal%20and%20warm%20amber%20palette%2C%20moody%20atmospheric%20lighting%2C%20cinematic%20composition%2C%20high%20detail%20illustration&width=600&height=400&seq=manhwa-genre-04&orientation=landscape",
  },
  {
    name: "科幻未来",
    en: "Sci-Fi",
    count: "160+ 部",
    desc: "赛博都市、机甲与人造生命，畅想技术裹挟下的人类明天。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20of%20a%20futuristic%20cyberpunk%20city%20skyline%20with%20neon%20lights%20and%20flying%20vehicles%2C%20sci-fi%20mood%2C%20teal%20and%20coral%20neon%20palette%2C%20dramatic%20night%20lighting%2C%20wide%20cinematic%20composition%2C%20high%20detail%20illustration&width=600&height=400&seq=manhwa-genre-05&orientation=landscape",
  },
  {
    name: "治愈日常",
    en: "Slice of Life",
    count: "230+ 部",
    desc: "人间烟火与微小温暖，让疲惫的心在慢时光里被治愈。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20of%20a%20cozy%20peaceful%20seaside%20village%20cafe%20with%20warm%20sunlight%20and%20soft%20everyday%20life%20scenes%2C%20slice%20of%20life%20healing%20mood%2C%20warm%20coral%20and%20cream%20palette%2C%20gentle%20bright%20lighting%2C%20clean%20composition%2C%20high%20detail%20illustration&width=600&height=400&seq=manhwa-genre-06&orientation=landscape",
  },
];

export const newReleaseList: ManhwaItem[] = [
  {
    title: "白昼星辰",
    author: "闵书妍",
    score: 9.1,
    genre: "恋爱奇幻",
    tags: ["新连载", "双向救赎"],
    desc: "能看见别人「死亡倒计时」的少女，与倒计时归零却安然无恙的少年相遇。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20young%20couple%20bathed%20in%20bright%20daylight%20with%20faint%20glowing%20stars%2C%20tender%20romance%20fantasy%20mood%2C%20warm%20coral%20and%20soft%20teal%20palette%2C%20luminous%20ethereal%20lighting%2C%20clean%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-new-01&orientation=portrait",
  },
  {
    title: "灰色契约",
    author: "曹民宇",
    score: 9.0,
    genre: "都市奇幻",
    tags: ["新连载", "灵异", "契约"],
    desc: "落魄的契约律师，专门替人与未知存在谈判。每一份契约背后都藏着一个秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20sharp%20suited%20lawyer%20holding%20an%20ominous%20glowing%20contract%20in%20a%20moody%20grey%20and%20gold%20office%2C%20urban%20fantasy%20suspense%2C%20muted%20teal%20and%20warm%20coral%20accents%2C%20dramatic%20chiaroscuro%20lighting%2C%20cinematic%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-new-02&orientation=portrait",
  },
  {
    title: "春风便利店",
    author: "洪多彬",
    score: 9.0,
    genre: "治愈日常",
    tags: ["新连载", "深夜食堂"],
    desc: "开在春风街转角的小便利店，深夜来客们在这里交换各自的人生故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20warm%20glowing%20convenience%20store%20at%20night%20with%20friendly%20shopkeeper%20and%20soft%20spring%20blossoms%20outside%2C%20cozy%20healing%20slice%20of%20life%2C%20warm%20coral%20and%20cream%20palette%2C%20inviting%20lamplight%2C%20clean%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-new-03&orientation=portrait",
  },
  {
    title: "夜航星图",
    author: "卢智爱",
    score: 8.9,
    genre: "科幻冒险",
    tags: ["新连载", "星舰", "伙伴"],
    desc: "一艘失联多年的星舰突然现身，年轻领航员被卷入跨越银河的谜题之中。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20young%20starship%20navigator%20standing%20on%20a%20bridge%20overlooking%20a%20vast%20glowing%20galaxy%20nebula%2C%20epic%20sci-fi%20adventure%2C%20teal%20and%20coral%20cosmic%20palette%2C%20awe-inspiring%20lighting%2C%20cinematic%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-new-04&orientation=portrait",
  },
];

export const classicList: ManhwaItem[] = [
  {
    title: "苍穹之约",
    author: "许道贤",
    score: 9.8,
    genre: "史诗奇幻",
    tags: ["入坑神作", "初代经典"],
    desc: "开启一代人韩漫记忆的里程碑之作，宏大的世界观与深刻的角色塑造至今无人超越，是所有榜单绕不开的必看神作。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20legendary%20hero%20with%20a%20greatsword%20standing%20beneath%20a%20vast%20dramatic%20sky%20with%20clouds%2C%20iconic%20epic%20fantasy%2C%20warm%20gold%20coral%20and%20deep%20teal%20palette%2C%20majestic%20god-ray%20lighting%2C%20sweeping%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-classic-01&orientation=portrait",
  },
  {
    title: "零度英雄",
    author: "柳汉杰",
    score: 9.7,
    genre: "热血超英",
    tags: ["入坑神作", "群像"],
    desc: "能力并非天生的英雄们，用零度起点的坚持写就属于自己的传奇。动作分镜教科书般的存在。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20diverse%20team%20of%20superheroes%20in%20dynamic%20action%20poses%20on%20a%20city%20rooftop%2C%20iconic%20heroic%20style%2C%20bold%20coral%20and%20teal%20palette%2C%20dramatic%20sunlight%2C%20energetic%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-classic-02&orientation=portrait",
  },
  {
    title: "纸鸢与少年",
    author: "安世京",
    score: 9.6,
    genre: "治愈成长",
    tags: ["入坑神作", "温情"],
    desc: "山野少年与一只断线纸鸢的故事，用最朴素的情感打动无数读者，被称为「治愈系天花板」。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20boy%20holding%20a%20paper%20kite%20on%20a%20sunlit%20green%20hillside%20with%20warm%20breeze%2C%20gentle%20healing%20story%20mood%2C%20soft%20coral%20and%20cream%20palette%2C%20warm%20golden%20lighting%2C%20peaceful%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-classic-03&orientation=portrait",
  },
  {
    title: "末班电车",
    author: "姜礼仁",
    score: 9.5,
    genre: "都市温情",
    tags: ["入坑神作", "群像"],
    desc: "每晚十一点的末班电车上，乘客们短暂交汇又各自远去，拼凑出城市里最真实的人间。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20of%20a%20warm%20glowing%20subway%20train%20interior%20with%20diverse%20passengers%20at%20night%2C%20urban%20slice%20of%20life%20mood%2C%20teal%20night%20window%20and%20warm%20coral%20interior%20light%2C%20soft%20cinematic%20lighting%2C%20clean%20composition%2C%20high%20detail%20illustration&width=700&height=1000&seq=manhwa-classic-04&orientation=portrait",
  },
];

export const faqList: FaqItem[] = [
  {
    q: "好看的韩国漫画排行榜多久更新一次？",
    a: "我们的排行榜综合了读者评分、阅读热度与完读率等多项数据，通常在每周五进行一次整体刷新。其中「人气新作榜」每周更新，「高分神作榜」和「必看经典榜」以月度为单位做更审慎的重新排序，确保榜单既有时效性也足够稳定可靠。",
  },
  {
    q: "榜单里的评分是怎么来的？",
    a: "评分主要来自两大来源：一是平台读者真实打分，二是编辑部对剧情完成度、画工水准、角色塑造与续更稳定性的综合评估。我们会对两类评分做加权平均，并剔除明显的异常值，尽可能还原一部作品最真实的观感。",
  },
  {
    q: "新手想入坑韩国漫画，应该先看哪一部？",
    a: "如果你喜欢快节奏的冒险升级，可以从「猎魔人笔记」入手；偏爱细腻情感线则推荐「星辰之约」；想体验最经典的入坑神作，直接看「苍穹之约」准没错。每部作品的榜单页都附有适合人群标签，方便你快速判断是否对味。",
  },
  {
    q: "为什么有些高分作品在人气榜上看不到？",
    a: "高分榜侧重作品综合品质，人气榜则更看重近期讨论度与阅读热度，两者评价维度不同。一些口碑极佳的老牌经典虽然稳定在必看榜前列，但由于追更热度回落，可能不会频繁出现在人气榜上，这属于正常现象。",
  },
  {
    q: "榜单中的新作多久能进入正式排名？",
    a: "新连载作品需连载满十二话且保持稳定更新，才有资格进入「人气新作榜」参与排序。编辑会重点关注前六话的世界观建立与节奏把控，只有在读者反馈与编辑评估双达标后，才会被提入更高层级的榜单。",
  },
  {
    q: "如何向编辑部推荐冷门但优质的作品？",
    a: "我们非常欢迎这样的推荐。你可以通过页面底部的联系方式，把作品名、作者以及你推荐的理由发送给我们。编辑部会结合数据与人工审读，将真正优质的冷门佳作定期补入相应榜单，让好作品不被埋没。",
  },
];